export default "__VITE_ASSET__CVrbqEOo__"